import instance from "../components/general/AxiosInterceptor";
const controller = "/api/complement";

export const createComplementApi = (payload) => {
  return instance.post(`${controller}/create-complement`, payload);
};

export const updateComplementApi = async (payload) => {
  const {complementId, body} = payload;
  const response = await instance.put(`${controller}/update/${complementId}`, body);
  return response.data;
};

export const getComplementByIdApi = async (complementId) => {
  const response = await instance.get(`${controller}/info/${complementId}`); 
  return response.data.body;
};

export const searchComplementsApi = async (body, params) => {
  const response = await instance.post(`${controller}/list-complements?page=${params.page}&size=${params.pageSize}`, { ...body }); 
  return response.data?.body;
};

export const cancelComplementApi = (complementId) => {
  return instance.post(`${controller}/cancel/${complementId}`, {});
}
export const markAsFixedComplementApi = (id) => {
  return instance.post(`${controller}/mark-as-fixed/${id}`, {});
}

export const fixComplementApi = async (id, body) => {
  const response = await instance.put(`${controller}/fix/${id}`, body); 
  return response.data;
};

export const downloadPjsApi = async (id) => {
  const response = await instance.post(
    `${controller}/download-pjs/${id}`, 
    {},
    { responseType: 'blob' } 
  );
  const contentType = response.headers.get('content-type');
  const extenetion = contentType.includes("application/pdf") ? "pdf" : "zip";
  const filename = `complement_${id}.${extenetion}`;
  return {
    blob: response.data,
    filename,
    contentType: response.headers['content-type'],
  };
};
